module.exports = __webpack_public_path__ + "static/media/search-black.a6203c63.svg";